import { Textarea as BaseTextArea } from '@/components/ui/textarea'

import { isFieldInvalid } from '@/utils'

import { FieldWrapper } from './field-wrapper'
import { useFieldContext } from './form'

export type TextAreaProps = {
  label?: string
  required?: boolean
} & React.ComponentProps<typeof BaseTextArea>

export const TextArea = (props: TextAreaProps) => {
  const field = useFieldContext<string>()
  const isInvalid = isFieldInvalid(field)

  return (
    <FieldWrapper field={field} label={props.label} required={props.required}>
      <BaseTextArea
        aria-invalid={isInvalid || undefined}
        className="rounded-md"
        data-invalid={isInvalid || undefined}
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        onChange={(e) => {
          field.handleChange(e.target.value)
        }}
        value={field.state.value}
        {...props}
      />
      {props.maxLength && (
        <div className="text-muted-foreground -mt-1 text-end text-xs">
          {(field.state.value as string)?.length || 0}/{props.maxLength}
        </div>
      )}
    </FieldWrapper>
  )
}
